export const SET_TIMECODE_LOADING = 'SET_TIMECODE_LOADING'
export const SET_TIMECODE = 'SET_TIMECODE'
export const ADD_TIMECODE = 'ADD_TIMECODE'
export const EDIT_TIMECODE = 'EDIT_TIMECODE'
export const DELETE_TIMECODE= 'DELETE_TIMECODE'
export const DEFAULT_TIMECODE= 'DEFAULT_TIMECODE'
